import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { AppState } from './app.reducer';
import { filter, take } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import * as fromCart from './store/cart.actions';
import { ICartProduct } from './models/cart.model';
import { cartProducts } from './store/cart.selectors';
import { combineLatest, Observable, of, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CartResolverService implements Resolve<ICartProduct[] | null> {

  constructor(
    private store: Store<AppState>
  ) {
  }

  resolve(): Observable<ICartProduct[]> {
    return combineLatest([
      this.store.select('cart'),
      this.store.select('organizationInfo')
    ]).pipe(
      filter(([, organizationInfo]) => organizationInfo.organizationInfo !== null),
      take(1),
      switchMap(([cartState, organizationInfo]) => {

        if (cartState.organizationCode !== organizationInfo.organizationCode) {
          this.store.dispatch(fromCart.cartFetchAction(organizationInfo.organizationCode));
          return this.store.select(cartProducts)
            .pipe(
              take(1)
            );
        } else {
          return of(cartState.products);
        }
      })
    );
  }
}
